import React, { PureComponent } from 'react';
import bindAll from 'lodash.bindall';
import event, { EVENTS } from '../../lib/event.js';
import styles from './style.css';
import StepsCardLineBtn from './steps-card-line-button';
import {BUTTONS} from '../../guide/steps-runtime';
import {GUIDE_MODE} from '../../lib/constant';

class ChatFooter extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            // 'onDrag',
            // 'handleStop',
            // 'showTips'
        ]);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }

    handleShowTaskModal(){
        event.emit(EVENTS.CHAT_SHOW_TASK_MODAL);
    }

    handleExit(){
        event.emit(EVENTS.STEP_EXIT_GUIDE_MODE, BUTTONS.EXIT_GUIDE_MODE);
    }

    render() {
        const { cardButton, btnType, position,mode,stepLast } = this.props

        return (
            <div className={styles.chatBtn}>
                {
                    position === 'bottom' && 
                    <button className={styles.singleBtn} onClick={()=>this.handleShowTaskModal()}>任务</button>
                }
                {
                    mode === GUIDE_MODE && position === 'bottom' &&
                    <button className={styles.singleBtn} onClick={()=>this.handleExit()}>{BUTTONS.EXIT_GUIDE_MODE.button}</button>
                }
                {
                    cardButton.map((item) => (
                        <StepsCardLineBtn key={item.button} btn={item} btnType={btnType} mode={mode} stepLast={stepLast} />
                    ))
                }
            </div>
        );
    }
}

export default ChatFooter;
